export default __webpack_public_path__ + "static/media/contacto_3.dec8986b.jpeg";